import React, { useState, useContext, useEffect } from "react";
import { StyleSheet, Image, Text, View } from "react-native";
import * as Yup from "yup";
// import { encrypt, decrypt } from 'secure-json-encryptor'   https://dichapp.com/AppNavigator/Feed/recPassword?seedId=142&email=a@gmail.com;
// import { enc as prodEncrypt, dec as prodDecrypt } from './obfuscated';
//import { AESEncryptionKey, aesEncryptAsync, aesDecryptAsync } from 'expo-crypto';
import Screen from "../components/Screen";
import {
  ErrorMessage,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
import storage from "../auth/storage";
import connectionConfig from "../config/settings";
import colors from "../config/colors";
//import settingStorage from "../config/settingStorage";
//import AppNavigator from "../navigation/AppNavigator";
// import configurationPost from "../config/configurationPost";
// import routes from "../navigation/routes";
//import AuthContext from "../auth/context";

const validationSchema = Yup.object().shape({
  email: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(4).label("Password"),
});

function RecPaswordScreen(props) {

var random 
useEffect(() => {
  debugger
  if(props.route.params === undefined || props.route.params === null){
    console.log(' /////// iiiiiiiiiiiiii')
    setUserValidate(true)
  }
  else{
    console.log(' /////// ', props.route.params.metric, props.route.params.random, props.route.params)

    validateUser( props.route.params.metric,  props.route.params.random, props.route.params.token)
  }
  //encriptador()
}, []);


  const [loginFailed, setLoginFailed] = useState(false);
  const[userValidate, setUserValidate] = useState(false)
  var access_fixo = []
  var error_message = '';

// Encriptar datos
// const encriptador = async (email, seedId ) => {
//     const secretKey = 'tu-contraseña-secreta';

//     const sensitiveData = { user: 'john', token: 'abc123' };

//     const encrypted = await encrypt(sensitiveData, secretKey);
//     console.log('Encriptado:', encrypted); // Un string en base64

//     // Desencriptar datos
//     const decrypted = await decrypt(encrypted, secretKey);
//     console.log('Desencriptado:', decrypted); // { user: 'john', token: 'abc123' }
// }

    const validateUser = async (metric, random, token) => {
    //debugger
    var post_values = {
      metric : metric,
      random : random,
      token : token
    }
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
  // alert('login submit')
    console.log('log')
    //solicita el servicio para login fixo remoto
    await fetch(connectionConfig.apiUrl+'/validateUserPass/', configurationPost)
      .then(response => response.json())
      .then(response => {
        debugger   //alert('login submit')
        if(response.data.length > 0){  
            setUserValidate(false)
        }else{
        setUserValidate(true)
        }
        console.log('la valid', response)
      })
      .catch(err =>{
        console.log('login fixo failed :( review internet service', err )
      })  
  }
  
  
    const handleSubmitSql = async ({  password, password2 }) => {
    debugger
    setLoginFailed(false);
    var post_values = {
      random : props.route.params.random,  
      metric : props.route.params.metric,
      password : password, 
      token : props.route.params.token
    }
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
   // configurationPost.body = JSON.stringify(post_values)
  // alert('login submit')
    console.log('log')
    //solicita el servicio para login fixo remoto
    if(password === '' || password2 === ''){
      alert('Por favor, completa todos los campos');
    }if(password === password2){
       await fetch(connectionConfig.apiUrl+'/passotas/', configurationPost)
      .then(response => response.json())
      .then(response => {
        debugger   //alert('login submit')
              //alert('login submit response 555555', response.data.length())
        setUserValidate('listo')
        console.log('login regresa', response)
      })
      .catch(err =>{
        console.log('login fixo failed :( review internet service /passotas/', err )
        setLoginFailed(true);       
      })
    }if(password !== password2){
      alert('Las contraseñas no coinciden, por favor verifica que sean iguales');
    }
  }

 
  return (
    <>
    {userValidate === false ?
    <Screen style={styles.container}>
      <Image style={styles.logo} source={require("../assets/fixdplanet1024.png")} />
                <Text style={styles.seedDescriptionForm} >
                        Ingresa tu contraseña nueva para recuperar tu cuenta.
                </Text>
      <Form
        initialValues={{ email: "a@gmail.com", password: "" }}
        onSubmit={handleSubmitSql}
        validationSchema={validationSchema}
      >
        <ErrorMessage
          error="Invalid email and/or password."
          visible={loginFailed}
        />
        <FormField
          autoCapitalize="none"
          autoCorrect={false}
          icon="lock"
          name="password2"
          placeholder="Nueva contraseña"
          secureTextEntry
          textContentType="password"
        />
        <Text style={styles.seedDescriptionForm} >
            Repite tu contraseña nueva para confirmar que es correcta.
        </Text>
        <FormField
          autoCapitalize="none"
          autoCorrect={false}
          icon="lock"
          name="password"
          placeholder="Repite tu nueva contraseña"
          secureTextEntry
          textContentType="password"
        />

        <SubmitButton title="Enviar nueva contraseña " />
      </Form>
    </Screen>
    : userValidate === 'listo' ?
        <Text style={styles.seedDescription} >
            Listo, tu contraseña ha sido actualizada correctamente, ahora puedes iniciar sesión con tu nueva contraseña.
        </Text>

    :
         <Text style={styles.seedDescription} > 
            No dijiste la palabra mágica para recuperar tu cuenta, por favor revisa tu correo electrónico y sigue las instrucciones para recuperar tu cuenta.
        </Text>
    } 
  </>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  logo: {
    width: 80,
    height: 80,
    borderRadius:50,
    alignSelf: "center",
    marginTop: 50,
    marginBottom: 20,
  },
  seedDescription: { 
    color: colors.green,
    marginTop: '30%',
    marginBottom: 20,
    fontSize: 18,
    textAlign: "center",
    alignSelf: "center",
    width: '100%',
     height: '20%',
     backgroundColor: colors.fondoInput,
     borderRadius: 10,
     padding: 10,
  },
    seedDescriptionForm: { 
    color: colors.green,
    marginTop: '3%',
    //marginBottom: 20,
    fontSize: 18,
    textAlign: "center",
    //alignSelf: "center",
    width: '100%',
    // height: '20%',
    //  backgroundColor: colors.fondoInput,
    //  borderRadius: 10,
    //  padding: 10,
  },
//   containerMessage: {
//     padding: 10,
//     width: '80%',
//      height: '80%',
//      backgroundColor: colors.danger
//   },
});

export default RecPaswordScreen;
